const prototypes = {
  slogan: 'On-demand UX/UI feedback',
  slogan_1: '♿️  Review accessibility and fix basic UI flaws',
  slogan_2: '🤖  Simulate user behaviour on prototypes',
  slogan_3: '📣  Source human feedback in seconds',
  scenarios: 'Challenges',
  select_flow: 'Select a flow',
  configure_scenario: 'Configure the challenge',
  no_flows: 'No flows found',
  no_flows_description:
    'This page does not contain any flows.\nPlease check if your flow have a starting points and is located on the active page.',
  all_reports: {
    title: 'All reports',
    subtitle: 'Review and organize tests across your product',
  },
  journey_heuristics: {
    title: 'Journey Heuristics',
    subtitle: 'Report on the metric progress of your product journeys',
    flow_name: 'Flow name',
    select_category: 'Select category',
    select_journey: 'Select journey',
    filters: {
      product_category: {
        title: 'Product category',
        activation: 'Activation',
        retention: 'Retention',
        expansion: 'Expansion',
      },
      journey_name: {
        title: 'Journey name',
        all: 'All journeys',
        time_to_first_value: 'Time to first value',
        navigation_and_wayfinding: 'Navigation & wayfinding',
        task_and_workflow_management: 'Task & workflow management',
        output_and_execution: 'Output & execution',
        invite_a_team_mate: 'Invite a team mate',
        upgrade_plan_higher: 'Upgrade Plan higher',
      },
      metrics: {
        title: 'Metrics',
        no_selected: 'No metrics selected',
        n_selected: '{{amount}} selected',
        success_rate: 'Success rate',
        time_on_task: 'Time on task',
        drop_off: 'Drop off',
        miss_clicks: 'Miss-clicks',
        interactions: 'Interactions',
        screens: 'Screens',
        avg_interactions_per_screen: 'Avg interactions per screen',
        avg_screens_per_sim: 'Avg screens per simulation',
      },
    },
  },
  all_challenges: 'All challenges',
  no_challenges: 'Challenge your first prototype',
  no_challenges_description:
    'Test interactive prototypes by setting challenges against flows for AI & humans to accomplish',
  no_prototype_yet: 'Do not have a prototype yet?',
  add_first: 'Add first',
  title: 'Title',
  n_confidence: '{{n}}% confidence in taken actions',
  no_confidence: 'No confidence',
  title_placeholder: 'Enter challenge title',
  enter_prompt: 'Enter a prompt',
  enter_url_prompt: 'Enter your test prompt',
  enter_url_prompt_placeholder:
    'Describe the exact task the AI should complete (e.g. “Sign into the app” or “Add a product to cart.”)',
  choose_how_many_simulations: 'Choose how many simulations',
  dont_skip_variants: 'Include all possible variants',
  dont_skip_variants_tooltip:
    "This option affects speed. If your flow doesn't seem to work or requires lots of variants tick this issue but be prepared for longer snapshot times.",
  writing_a_good_prompt: 'Writing a good prompt',
  intro_message: 'Challenge prompt',
  intro_message_placeholder: 'Describe the task for AI to complete',
  challenge_description_title: 'What is a challenge prompt?',
  challenge_description_text_1:
    'Prompts should state goals specific to your product. The more specific, the better.',
  challenge_description_text_2:
    '<highlight>Avoid vague instructions</highlight> like “Finish the flow”, instead try “Use the Search bar to find a Size 10 black dress”.',
  final_question: 'Final question',
  final_question_placeholder:
    'Write a question to ask testers if they were able to complete the task. e.g. “Were you able to sign up?”',
  generating_prototype: 'Generating a challenge',
  generating_info_10_minutes: 'up to 10 minutes',
  generating_info_3_minutes: 'up to 3 minutes',
  generating_info_1_minute: 'less than 1 minute',
  saving_step: '{{number}}/{{max}}',
  reading_pages: 'Calculating steps to save',
  waiting_for_all_to_save: '{{progress}}%',
  reading_data_from_canvas: 'Loading data from canvas',
  final_screen: 'Final screen',
  final_screen_placeholder: 'Select the final screen of the flow',
  final_trigger_element: 'Final click element',
  final_trigger_element_placeholder:
    'Select an interaction that finishes the challenge',
  final_click: 'Final click',
  final_click_element_description:
    'When your challenger interacts with this element, it will end your challenge.',
  selected_element: 'Selected element',
  submit_click_element: 'Submit',
  feedback_placeholder: 'Enter you answer here.',
  scenario_created: 'New challenge created',
  scenario_created_description_one: '{{count}} page was successfully generated',
  scenario_created_description_other:
    '{{count}} pages were successfully generated',
  share_scenario: 'Done! Share your challenge',
  passcode: 'Passcode',
  share: 'Copy invitation & close',

  overview: 'Overview',
  suggested_improvements: {
    title: 'Suggested improvements',
    description_one:
      'The top screen where users dropped off, hesitated, or misclicked, and how to make them better.',
    description_other:
      'The top 3 screens where users dropped off, hesitated, or misclicked, and how to make them better.',
    no_confusions: 'There are no confusions.',
  },
  view_simulation: 'View simulation',
  password_protection: {
    title: 'Passcode',
    placeholder: 'Enter the passcode here',
    subtitle: 'Enter the passcode to start',
    invalid_passcode: 'Invalid passcode',
  },
  sharing_link: 'Challenge link',
  continue_as: 'Continue as {{name}}',
  continue_anonymously_text: "or, if you don't want to share your data",
  continue_anonymously: 'Continue anonymously',
  continue_to_scenario: 'Continue to the challenge',
  sign_to_your_account: 'Sign in to your Velocity account',
  you_are_signed_in_as: 'You are signed in as',
  open: 'Preview challenge',
  details: 'Details',
  run: 'Run',
  no_simulations: 'No tests',
  no_successful_simulations: 'No finished tests',
  simulations_with_errors_one:
    '{{count}} test aborted due to an internal issue.',
  simulations_with_errors_other:
    '{{count}} tests aborted due to an internal issue.',
  simulations_aborted_one: '{{count}} test aborted by user.',
  simulations_aborted_other: '{{count}} tests aborted by user.',
  copy_link: 'Copy link',
  open_web_report: 'Full report',
  open_in_figma: 'Open in Figma',
  ai_report: 'AI Proxy report',
  simulate_user_interactions: 'Simulate user interactions',
  simulation_in_progress: 'Simulation in progress',
  vibe_simulation_in_progress_one: '{{count}} simulation in progress',
  vibe_simulation_in_progress_other: '{{count}} simulations in progress',
  submit_review: 'Submit',
  restart_scenario: 'Restart challenge',
  restart: 'Restart',
  abort: 'Abort',
  rate_your_experience: 'Rate your experience',
  hint: 'Hint',
  task_description: 'Challenge prompt',
  anonymous: 'Anonymous',
  reviews: 'Reviews ({{count}})',
  no_reviews:
    'Share the challenge with your test users to start getting the reviews.',
  time: '{{minutes}}min {{seconds}}s',
  canceled: 'Not completed',
  completed: 'Completed',
  ai_simulation: 'AI Simulation',
  test_with_humans: 'Test with humans',
  human_testing: 'Human testing',
  human_testing_text: 'AI validated. Now test with humans.',
  set_up_human_testing: 'Share test link',
  user_simulation: 'User Simulation',
  ai_completed: 'Simulation completed the challenge',
  ai_canceled: 'Simulation failed the challenge',
  confirm_scenario_restart: 'Confirmation',
  confirm_scenario_restart_description: 'Do you want to restart the challenge?',
  render_clickmap: 'Render clickmap',
  clear_clickmap: 'Clear',
  times_opened: '# opened',
  unique: 'unique',
  number_of_runs: '# of runs',
  avg_rating: 'Avg. rating',
  rating: 'Rating',
  completion: 'Completion',
  thank_you: 'Thank you for completing the challenge',
  thank_you_text: 'You can now close this tab.',
  question: 'Question',
  question_placeholder: 'Question this interaction...',
  send_question: 'Send question',
  screen_details: 'Screen details',
  ask_question: 'Ask question',
  thinking_tab: 'Thinking',
  conversation_tab: 'Conversation ({{count}})',
  expand_review: 'Show thinking',
  collapse_review: 'Collapse thinking',
  stats: 'Stats',
  ai_proxy: 'AI Persona',
  see_details: 'Show thinking',
  boomer_proxy: 'Boomer Proxy',
  simulated_user: 'Simulated user',
  simulation_unsuccessful: 'Simulation unsuccessful',
  simulation_failed_error:
    'Simulation failed because of error. Please generate the challenge again.',
  simulation_successfull: 'Simulation successful',
  simulation_completed: 'Simulation completed the challenge',
  loop_start: 'Loop start',
  loop_finish: 'Loop finish',
  loop_step: 'Looped step',
  expand_loop: 'Show all attempts',
  collapse_loop: 'Hide all attempts',
  attempt_n: 'Attempt {{index}}',
  loop_explanation:
    'None of the actions atftempted by the simulation matched the actions available in the prototype.',
  page_n_of: 'Page {{index}} of {{total}}',
  step_n: 'Step {{number}}',
  ai_next_action: 'I am going to {{action}} on {{element}}',
  try_again: 'Run again',
  run_similar: 'Run similar',
  run_extended_sims: 'Run 10 more sims',
  run_3x_more_sims: 'Run 3x more',
  start_simulation: 'Start',
  stop_simulation: 'Stop',
  other_simulation_running:
    'Other simulation is running, please wait for it to finish.',
  loading_times: 'Loading times',
  loading_times_description:
    'The more layers (even hidden ones) in your flow, the longer it may take to import.',
  your_challenge: 'Your challenge',
  challenge_a_flow: 'Test a prototype',
  prototype_challenges: 'Prototype challenges',
  safety_tip: 'Your data is safe',
  safety_tip_description: 'We do not train AI with your designs',
  flows_on_this_page: 'Flows on this page:',
  flow_section: {
    title: 'Wrap flow screens in a new section (⌘ S) to reduce import time.',
    description: 'This reduces import time.',
    modal_title: 'Wrap flow screens in a section',
    modal_description:
      'To test, wrap all screens of the flow into a single parent section. This reduces import time.',
    understood: 'Acknowledge',
    tooltip: 'Wrap flow screens in a section',
  },
  result: 'Result',
  requirements: 'Requirements',
  speed_up_import: {
    modal_title: 'Speed up the import',
    modal_description:
      'Wrap all screens of the flow into a single parent section to reduce import time.',
    go_back: 'Go back and add a section',
    skip_and_proceed: 'Skip and proceed',
  },
  system_response: {
    unknown_delay: 'unknown',
    n_s: '{{delay}}s',
    n_ms: '{{delay}}ms',
    no_action:
      'The action attempted by the simulation did not match the actions available in the prototype. It will try to find another one.',
    no_available_action:
      'There are no available actions to be taken by the simulation.',
    navigated: 'Simulation navigated to the next screen.',
    navigated_after_delay:
      'Simulation navigated to the next screen after a {{delay}} delay.',
    used_default_action_and_navigated:
      'Intended action wasn\'t found, used "{{action}}" action and navigated to the next screen',
    used_default_action_and_changed_variant:
      'Intended action wasn\'t found, used "{{action}}" action and changed the variant of element',
    used_default_action_and_opened_overlay:
      'Intended action wasn\'t found, used "{{action}}" action and opened an overlay',
    used_different_action_and_navigated:
      'Intended action wasn\'t found, found similar action "{{selectedInstead}}" and navigated to the next screen',
    changed_variant: 'Simulation changed the variant of element',
    changed_variant_after_delay:
      'Simulation changed the variant of element after a {{delay}} delay.',
    used_different_action_and_changed_variant:
      'Intended action wasn\'t found, found similar action "{{selectedInstead}}" and changed the variant of element',
    changed_variant_and_navigated:
      'Simulation changed the variant of element and navigated to the next screen',
    opened_overlay: 'Simulation opened an overlay',
    opened_overlay_after_delay:
      'Simulation opened an overlay after a {{delay}} delay',
    closed_overlay: 'Simulation closed an overlay',
    closed_overlay_after_delay:
      'Simulation closed an overlay after a {{delay}} delay',
    used_different_action_and_opened_overlay:
      'Intended action wasn\'t found, found similar action "{{selectedInstead}}" and opened an overlay',
    waited_long_enough:
      'Simulation will try to perform another action after waiting {{time}}s.',
    waited_long_enough_skipped:
      'Simulation will try to perform another action and skip waiting.',
  },
  delete_challenge: {
    title: 'Delete the challenge',
    with_responses_description: `You are about to delete the challenge that already got responses.
This action cannot be undone. Do you want to proceed?`,
    description: `You are about to delete the challenge.
This action cannot be undone. Do you want to proceed?`,
  },
  save_error: {
    unable_to_generate_page:
      'Unable to import one of the pages. Please verify if the whole flow is located within the single section at the same level.',
    unable_to_generate_partial:
      'Unable to import of the parts. Please verify if the whole flow is located within the single section at the same level.',
    unable_to_save_page_image:
      'Unable to save page content, please try to generate the challenge again.',
    unable_to_save_partial_image:
      'Unable to save part content, please try to generate the challenge again.',
    page_too_big:
      'Page [{{page}}] is too big, maximum allowed size is 2000x2000px.',
    larger_sizes_coming_soon: '...larger sizes coming soon!',
    unable_to_find_starting_node: 'Unable to find starting node.',
  },
  status: {
    aborted: 'User Simulation was unable to finish given task.',
    aborted_with_explanation:
      'User Simulation was unable to finish given task, saying "{{explanation}}"',
    aborted_error:
      'User Simulation was unable to finish given task due to error: "{{explanation}}". Please generate the challenge again.',
    aborted_by_user: 'User Simulation was aborted by user.',
    aborted_cycle_detected:
      'User Simulation was unable to satisfy the given challenge - The simulation was aborted because it attempted the same activity, the same way, 3 times.',
    aborted_page_cycle_detected:
      'User Simulation was unable to satisfy the given challenge - The simulation was aborted because it attempted the same activity, the same way, 5 times.',
    pending: 'User Simulation is reviewing given task.',
    finished_with_ai_and_interaction:
      'User Simulation was able to finish given task - All specified challenges have been fulfilled and the selected final element was triggered.',
    finished_with_ai_and_indirect_interaction:
      'User Simulation was able to finish given task - All specified challenges have been fulfilled and the selected final element was triggered.',
    finished_with_ai:
      'User Simulation was able to finish given task - all specified challenges are fulfilled according to the simulation.',
    finished_with_interaction:
      'User Simulation was able to finish given task - final click element was found and interacted with.',
    finished_with_indirect_interaction:
      'User Simulation was able to finish given task - simulation interacted with an element that was a part of the selected final click element.',
    in_progress: 'Please keep the plugin open.',
    waiting: 'Waiting for simulation',
    aborted_timeout: 'Simulation was aborted by timeout.',
  },
  errors: {
    scenario_already_exists: 'Challenge with this name already exists',
    scenario_has_no_pages: 'This challenge has no pages',
    scenario_not_found: 'This challenge directs to non existing project.',
  },
  validation: {
    title_cannot_be_empty: "Challenge title can't be empty",
    title_too_short:
      'Challenge title must have at least {{minLength}} characters',
    title_too_long:
      'Challenge title must be no longer than {{maxLength}} characters',
    intro_message_cannot_be_empty: "Challenge prompt can't be empty",
    intro_message_too_short:
      'Challenge prompt must have at least {{minLength}} characters',
    intro_message_too_long:
      'Challenge prompt must be no longer than {{maxLength}} characters',
    final_question_too_short:
      'Final question must have at least {{minLength}} characters',
    final_question_too_long:
      'Final question must be no longer than {{maxLength}} characters',
    final_trigger_element_cannot_be_empty:
      'Final click element has to be selected',
    rating_cannot_be_empty: 'You need to add rating',
    rating_too_low: 'The minimum rating is {{min}}',
    rating_too_high: 'The maximum rating is {{max}}',
    feedback_too_short: 'Feedback must have at least {{minLength}} characters',
    feedback_too_long:
      'Feedback must be no longer than {{maxLength}} characters',
    question_cannot_be_empty: "Question can't be empty",
    question_too_short: 'Question must have at least {{minLength}} characters',
    question_too_long:
      'Question must be no longer than {{maxLength}} characters',
    user_name_too_short: 'Name must have at least {{minLength}} characters',
    user_name_too_long: 'Name must be no longer than {{maxLength}} characters',
    email_is_not_valid: 'Email is not valid',
    email_too_long: 'Email be no longer than {{maxLength}} characters',
    provide_email_or_name: 'You have to provide your email or your name',
    amount_cannot_be_empty:
      'You have to select the amount of simulations to perform',
    success_rate_too_low: 'Success rate threshold should be at least {{min}}%',
    success_rate_cannot_be_empty: "Success rate threshold can't be empty",
    success_rate_too_high:
      'Success rate threshold should be a maximum of {{max}}%',
    drop_off_rate_too_low:
      'Drop off rate threshold should be at least {{min}}%',
    drop_off_rate_too_high:
      'Drop off rate threshold should be a maximum of {{max}}%',
    drop_off_rate_cannot_be_empty: "Drop-off rate threshold can't be empty",
    missclick_rate_too_low:
      'Missclick rate threshold should be at least {{min}}%',

    missclick_rate_too_high:
      'Missclick rate threshold should be a maximum of {{max}}%',
    missclick_rate_cannot_be_empty: "Missclick rate threshold can't be empty",
    time_to_success_too_low: 'Time on task should be at least {{min}}s',
    time_to_success_too_high: 'Time on task should be a maximum of {{max}}',
    time_to_success_cannot_be_empty: "Time on task can't be empty",
    min_human_participants_too_low:
      'Minimum allowed number of human participants is {{min}}',
    min_human_participants_too_high:
      'Maximum allowed number of human participants is {{max}}',
    min_human_participants_cannot_be_empty:
      "Min human participants can't be empty",
    min_ai_participants_too_low:
      'Minimum allowed number of simulated participants is {{min}}',
    min_ai_participants_too_high:
      'Maximum allowed number of simulated participants is {{max}}',
    min_ai_participants_cannot_be_empty:
      "Min simulated participants can't be empty",
    website_url_cannot_be_empty: "URL address can't be empty",
    website_url_is_incorrect:
      'Enter a valid website URL (e.g. https://example.com)',
    website_prompt_cannot_be_empty: "Prompt can't be empty",
    website_prompt_too_short:
      'Prompt is too short, min {{minLength}} characters required.',
  },
  now_test_with_humans: 'Test with humans',
  guest_notice: {
    title: 'Sign up to complete simulation',
    finished_title: 'Sign up to get full details',
    text: 'Unlock full simulation results for free',
    finished_text: 'Simulation is finished',
    badge: 'More steps hidden',
  },
  card_text: 'Can AI navigate your prototype?\nFind friction points.',
  get_full_simulation: 'Get full simulation',
  interactive_probability: {
    title: 'About confidence scores',
    high: 'High',
    medium: 'Medium',
    low: 'Low',
  },
  confidence_score: {
    high: 'High confidence',
    medium: 'Medium confidence',
    low: 'Low confidence',
    tooltip:
      'This score represents how likely it is that a user would take this action in the prototype.',
    tooltip_high: 'A high score means the action is very probable probable',
    tooltip_medium:
      'A medium score means the action is somewhat probable but not certain',
    tooltip_low: 'A low score means the action is unlikely to be chosen',
    repeated_action: 'This is the {{index}} attempt on this page',
  },
  navigate: 'Navigate',
  analysing: 'Analysing',
  loading: 'Loading',
  pass: 'Test pass x1',
  fail: 'Test fail x1',
  passed_n_of_m: '{{passed}}/{{all}} Tests passed',
  n_human_reviews: '{{n}} human reviews',
  n_simulated_interactions: '{{n}} simulated interactions',
  n_average_interactions: '{{n}} average interactions per simulation',
  n_average_views: '{{n}} average views per simulation',
  n_to_m_interactions: '{{n}} - {{m}} interactions per simulations',
  n_human_interactions: '{{n}} human interactions',
  // average_path_interactions: '{{n}} average intera'
  running_in_background: '(Close anytime, email on finish)',

  run_another_simulation: {
    title: 'New simulation',
    text: 'Have you made any significant changes to your flow? If that\'s the case click "Yes" and generate a new snapshot.',
  },
  participants: {
    title: 'Participants',
    all: 'All',
    human: 'Human',
    simulated: 'Simulated',
    add: 'Add participants',
  },
  report: {
    confidence: {
      title: 'Confidence',
      get_more: 'Get more confidence',
      level: 'Level {{level}}',
      tooltip_title:
        'More participants = higher confidence. Humans always count more than AI.',
      how_many_i_need: `How many participants do I need?
This depends on your risk level.`,
      level_0_description:
        'Too few to trust the results. Build confidence with more data points.',
      level_1_description: 'Obvious issues should be clear.',
      level_2_description: 'Patterns are now more obvious.',
      level_3_description:
        'Lowest risk, highest confidence can only ever be achieved with human test users. ',
      simulation_only_tooltip_title: 'More simulations = higher confidence.',
    },
    success_rate: {
      title: 'Success rate',
      tooltip: 'How many succeded',
    },
    confusions: {
      title: 'Confusions',
      tooltip: 'Screens that caused confusion',
      description_one: 'Most confusing screen',
      description_other: 'Top {{n}} confusing screens',
      users_one: '{{count}} user',
      users_other: '{{count}} users',
      simulations_one: '{{count}} simulation',
      simulations_other: '{{count}} simulations',
      users_and_simulations: '{{users}} and {{simulations}}',
      metrics: {
        high_missclick_rate: 'High missclick rate',
        high_drop_off_rate: 'High drop off rate',
        long_dwell_time: 'Long dwell time',
        missclicks_description_human_simulated:
          '{{participants}} clicked the wrong area, likely due to unclear layout or CTA placement.',
        dropoffs_description_human_simulated:
          '{{participants}} didn’t follow the intended path, likely confused by layout or copy.',
        duration_description:
          'Users lingered too long, suggesting hesitation or uncertainty.',
      },
      see_more: 'See more',
    },
    decision: {
      title: 'Meets requirements?',
      tooltip:
        'Result is based on all usability metrics and the number and type of participants.',
      go: 'Pass',
      no_go: 'Fail',
      pending: 'Pending',
      score: '{{score}}% confidence',
      for_a_yes: 'For a PASS:',
      reduce: 'Reduce: {{list}}',
      increase: 'Increase: {{list}}',
      drop_offs: 'Drop off rate',
      human_test_participants: 'human test participants',
      ai_simulations: 'AI simulated test participants',
      reduce_by: 'Reduce by {{value}}',
      increase_by: 'Increase by {{value}}',
      target_met: 'Target met',
    },
    metric: {
      title: 'Metric',
      missclick_rate: 'Missclick rate',
      missclick_rate_tooltip:
        'The percentage of unforeseen taps or clicks participants made while interacting with your product during a specific task.',
      success_rate: 'Success rate',
      success_rate_tooltip:
        'The percentage of participants who successfully completed the challenge.',
      duration: 'Time on task',
      duration_tooltip: 'Duration',
      drop_off_rate: 'Drop off rate',
      drop_off_rate_tooltip:
        'The percentage of participants who abandoned the challenge before reaching the specified goal.',
      average_duration: 'Time on task',
      average_duration_tooltip:
        'The average amount of time participants took to successfully complete the challenge.',
      required: '{{value}} required',
      avg_sim_interactions: 'Average interactions per simulation',
      avg_views_count: 'Average screens per simulation',
      sim_interactions: 'Interactions per simulation',
      avg_human_interactions: 'Average interactions per human test',
      sim_views: 'Screens per simulation',
      human_participants: 'Human participants',
      ai_participants: 'AI participants',
      show_less: 'Show less',
      more_metrics: '3 more metrics',
    },
    test_participants: {
      title: 'Test participants',
      tooltip: '',
      human: 'Human',
      ai_simulated: 'AI simulated',
      human_participants: 'Human participants',
      ai_simulated_participants: 'AI simulated participants',
      required: '{{count}}+ required',
    },
    usability_results: {
      title: 'Usability results',
      tooltip: 'Usability results',
    },
    details: {
      title: 'Details',
      tooltip: 'Details',
    },
    paths: {
      title: 'Challenge Paths',
      simulated: {
        successful: 'Successful',
        unsuccessful: 'Unsuccessful',
        description:
          'The path the simulations took and how they completed the challenge',
        successful_text: 'Simulations that completed the challenge',
        unsuccessful_text: 'Simulations that didn’t completed the challenge',
        participant_one: '{{count}} Simulated Participant',
        participant_other: '{{count}} Simulated Participants',
      },
      human: {
        successful: 'Successful',
        unsuccessful: 'Unsuccessful',
        description:
          'The path the users took and how they completed the challenge',
        successful_text: 'Users that completed the challenge',
        unsuccessful_text: 'Users that didn’t completed the challenge',
        participant_one: '{{count}} Human Participant',
        participant_other: '{{count}} Human Participants',
      },
      category: {
        accessible: 'Blurred vision',
        default: 'Agentic persona',
      },
      successful: 'Successful',
      unsuccessful: 'Unsuccessful',
      number: 'Path {{number}}',
      see_breakdown: 'See breakdown',
      see_details: 'See details',
      hide_details: 'Hide details',
      open_lightbox: 'View fullscreen',
      lightbox: {
        previous_screen: 'Previous screen',
        next_screen: 'Next screen',
        close: 'Close',
      },
      breakdown: {
        title: 'Path {{number}} - {{status}}',
        simulated: {
          description:
            'Individual simulation runs that followed this path through the prototype',
          runs_one: '{{count}} run',
          runs_other: 'This path contains <tag>{{count}}</tag> runs',
        },
        human: {
          description:
            'Individual participant runs that followed this path through the prototype',
          runs_one: '{{count}} run',
          runs_other: 'This path contains <tag>{{count}}</tag> runs',
        },
        run: 'Run {{number}}',
        view_review: 'View review details',
        empty: 'No individual runs are available for this path.',
        run_review: {
          title: 'Path {{pathNumber}} - Run {{runNumber}}',
          description: 'See how the review went and what the persona did.',
        },
      },
    },
    settings: {
      target_metrics: 'Target metrics',
      requirements: 'Requirements:',
      velocity_default: 'Velocity default',
      report_custom: 'Custom for this report',
      report: 'Report',
      team: 'Team',
      workspace: 'Workspace',
      figma_prototypes: 'Figma prototypes',
      vibe_prototypes: 'Websites',
      config: {
        title: 'Requirements for this report',
        figma_prototypes_title: 'Figma prototype requirements',
        vibe_prototypes_title: 'Website requirements',
        team_title: 'Team requirements',
        prototypes_title: 'Prototype requirements',
        reset: 'Reset',
        you_are_using: "You're currently using <config/> requirements.",
        editing_description: 'Editing these will affect this report only.',
        figma_prototypes_editing_description:
          'Editing these will affect all Figma reports unless a single report has custom settings.',
        vibe_prototypes_editing_description:
          'Editing these will affect all Vibe reports unless a single report has custom settings.',
        team_editing_description:
          'Editing these will affect all reports in this team unless overridden.',
        prototypes_editing_description:
          'Editing these will affect all reports of this type unless a single report has custom settings.',
        inheriting_from:
          'Not configured at this level.\nCurrently inheriting from <config/>.',
        success_rate_threshold: 'Success rate threshold:',
        success_rate_threshold_placeholder: '50',
        drop_off_rate_threshold: 'Drop-off rate threshold:',
        drop_off_rate_threshold_placeholder: '20',
        missclick_rate_threshold: 'Missclick rate threshold:',
        missclick_rate_threshold_placeholder: '20',

        time_to_success_threshold: 'Time on task rate threshold:',
        time_to_success_threshold_placeholder: '40',
        min_human_participants: 'Min human participants:',
        min_human_participants_placeholder: '0',
        min_ai_participants: 'Min AI participants:',
        min_ai_participants_placeholder: '11',
      },
      config_source: {
        FIGMA_PROTOTYPE: 'Figma prototype defaults',
        WEBSITE: 'Website defaults',
        VELOCITY_DEFAULT: 'Velocity defaults',
      },
    },
    delete: {
      title: 'Delete this report?',
      text: 'This will move this report to the trash.',
    },
    transfer: {
      title: 'Transfer this report?',
      text: 'Select the team you want to transfer this report to.',
      team_label: 'Team',
      team_placeholder: 'Select a team',
    },
  },
  compare: {
    changes: 'Changes',
    title: 'Compare A vs B',
    choose: 'Choose to compare',
  },
  websites: {
    simulation: {
      prompt_description_1:
        '<tag>Type a task below and our AI will simulate a real user completing it on your site.</tag> Be specific — the more detail you give, the better the the test.',
      prompt_description_2: 'Not sure what to write? Check out this blog post:',
      prompt_examples_info: 'Or click one of these examples:',
      example_1: 'Add a product to cart',
      example_2: 'Search for a specific product',
      example_3: 'Sign up for an account',
      loading_vibe: 'Loading your vibe',
      ready_for_magic: 'Psst... wanna see some magic?',
      prompt_placeholder: 'Describe the task for AI to complete...',
      reasoning_and_interactions: 'Reasoning & interactions',
      reasoning_and_interactions_wcag:
        'Reasoning, interactions & WCAG {{level}} checks',
      n_steps_completed_one: '{{count}} step completed',
      n_steps_completed_other: '{{count}} steps completed',
      results: 'Results',
      use_persona: 'Use {{persona}}',
      metrics: 'Metrics',
      loading: 'Your simulation is starting',
      wcag_appraisals_notice:
        'What this persona sees will be checked against WCAG {{level}} rules.',
      enter_prompt: 'Enter a prompt',
      ready_to_go: 'Ready to go!',
      passed: 'Test passed',
      failed: 'Test failed',
      meets_requirements: 'Meets requirements',
      test_passed: 'The simulation was able to complete your challenge',
      test_failed: 'The simulation was not able to complete your challenge',
      metrics_below:
        'Recorded UX metrics are below requirements set by your team',
      metrics_matched:
        'Recorded UX metrics matches requirements set by your team',
    },
    error: {
      cant_start: 'Unable to start a simulation, please try again later.',
    },
  },
  more_confidence: {
    title: 'Want more confidence in your results?',
    description:
      'Confidence is based on the number of users (human & simulated) your prototype has been tested with. The more tests you run, the more reliable your insights become.',
    test_with_humans: 'Test with humans',
    test_with_humans_text:
      'Challenge more humans to boost your confidence score.',
    run_more_simulations_one: 'Run {{count}} simulation',
    run_more_simulations_other: 'Run {{count}} simulations',
    run_extended_simulations_text:
      'Run more simulations to boost your confidence score.',
    set_up_human_testing_in_plugin: 'Set up human testing in plugin',
    simulation_in_progress:
      'A simulation is already running. Please wait for it to finish before starting another one.',
    select_persona_title: 'Select persona',
    select_persona_description:
      'Choose which persona should run this simulation.',
  },
  extended_simulation_in_progress: '{{amount}}x simulations in progress',
  human_testing_invitation: {
    text: 'You are invited to try out an interactive prototype for the {{name}}. Your feedback will help us refine the experience before launch.',
    prompt_subtitle: 'With the challenge prompt:',
  },
  report_invitation: {
    text: 'You are invited to view the report for the {{name}}.',
    prompt_subtitle: 'With the challenge prompt:',
  },
  simulations_amount_description: {
    x1: 'Initial feedback',
    x3: 'Compare and contrast',
    x10: 'Confidence boost… or reality check',
    x50: 'Good validation',
    x100: 'Booyah! 100% pre-human confidence',
  },
  notify_when_its_done: "Email me when it's done",
  demos: {
    spotify: 'Spotify onboarding',
    netflix: 'Netflix onboarding',
    apple: 'Apple calendar',
  },
  snapshot_warnings: 'Warnings',
  snapshot_warning_properties_one:
    'The simulations has started successfully but there’s an issue with your components. It looks like some variant properties are conflicting or missing. Try reviewing the variant panel in Figma to fix it. Close this modal to go see the simulation.',
  snapshot_warning_properties_other:
    'The simulations has started successfully but there’s an issue with {{count}} components. It looks like some variant properties are conflicting or missing. Try reviewing the variant panel in Figma to fix it. Close this modal to go to the simulation.',
  click_to_navigate: 'Click on the warning to navigate to the element.',
  personas: {
    select: 'Select persona',
    default: 'Agentic persona',
    accessible: 'Blurred vision',
    protanopia: 'Protanopia',
  },
  run_a_simulation: 'Run a simulation',
  new_simulation: 'New simulation',
  available_actions: 'Available actions',
  action_debug: {
    title: 'Action {{action}} on {{trigger}}',
    short: '{{action}} on {{trigger}}',
    after_seconds: 'after {{seconds}}s',
  },
  website_url_placeholder: 'https://example.com',
} as const;

export default prototypes;
